import React, {useEffect} from "react";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Header from "../component/Header";
import SubBanner from "../component/SubBanner";
import Footer from "../component/Footer";

import PersonalCareIcon from "../assets/images/search-blue-icon.svg";
import PostByImg from "../assets/images/blog/default-icon.svg";
import FacebookImg from "../assets/images/blog/facebook.svg";
import TwitterImg from "../assets/images/blog/twitter.svg";
import LinkedinImg from "../assets/images/blog/linkedin.svg";
import InstaImg from "../assets/images/blog/instagram.svg";

import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchResourceDetails, fetchResourceCategory } from "../features/resource/resourceActions";


import { Helmet } from "react-helmet-async";
import "../scss/blog.scss";

function ResourcesDetails() {
  const { slug } = useParams();

  const dispatch = useDispatch();
  const { resourceDetails, resourceCategories } = useSelector(
    (state) => state.resource
  );
  const { services } = useSelector((state) => state.service);

  useEffect(() => {
    dispatch(fetchResourceDetails(slug));
    dispatch(fetchResourceCategory({ page: 1, limit: 25 }));
  }, [dispatch, slug]);

 
  return (
    <>
      <Helmet>
        <title>{resourceDetails?.meta_title}</title>
        <meta name="description" content={resourceDetails?.meta_description} />
        <meta name="keywords" content={resourceDetails?.meta_keywords} />
      </Helmet>
      <main className="blog-page">
        <Header />
        <SubBanner HeaderTitle="Resources Details" />
        <>
          <section className="blog-details">
            <Container>
              <Row>
                <Col sm="12" lg="8" xxl="9" className="mb-4 mb-lg-0">
                  <div className="blog-details-box">
                    <h2>{resourceDetails?.title}</h2>
                    <div className="social-box">
                      <div className="post-by">
                        <div className="post-by-img">
                          <img src={PostByImg} alt="" />
                        </div>
                        <p>by {resourceDetails?.author}</p>
                      </div>
                      <ul>
                        <li>
                          <Link
                            to={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                              window.location.href
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={FacebookImg} alt="" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                              window.location.href
                            )}&text=${encodeURIComponent(resourceDetails?.title)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={TwitterImg} alt="" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                              window.location.href
                            )}&title=${encodeURIComponent(resourceDetails?.title)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={LinkedinImg} alt="" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={`https://www.instagram.com/?url=${encodeURIComponent(
                              window.location.href
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={InstaImg} alt="" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <img
                      className="blog-details-img"
                      src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${resourceDetails?.image}`}
                      alt=""
                    />
                    <div
                      className="post__content"
                      dangerouslySetInnerHTML={{
                        __html: resourceDetails?.description,
                      }}
                    ></div>
                  </div>
                </Col>
                <Col sm="12" lg="4" xxl="3">
                  <div className="blog-sidebar">
                    <div className="search-box">
                      <form>
                        <div className="input-group">
                          <img
                            className="personal-care-img"
                            src={PersonalCareIcon}
                            alt=""
                          />
                          <input
                            type="text"
                            id="PersonalCare"
                            name="personal_care"
                            placeholder="Search Personal Care"
                          />
                        </div>
                      </form>
                    </div>

                    {resourceCategories?.data?.length > 0 && (
                      <div className="sidebar-box">
                        <h3>Categories</h3>
                        <ul>
                          {resourceCategories.data.map((row, index) => (
                            <li key={index}>
                              <Link
                                to={
                                  "/resource-by-category/" + row.slug + "-" + row.id
                                }
                              >
                                {row.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {services?.data?.length > 0 && (
                      <div className="sidebar-box">
                        <h3>Popular Services</h3>
                        <ul>
                          {services?.data.map((row, index) => (
                            <li key={row.id + index}>
                              <Link to={"/service-details/" + row.slug}>
                                {row.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </>
      </main>
      <Footer />
    </>
  );
}
export default ResourcesDetails;
